
<script>
import store from '../store/index.js';
import {forEach} from 'lodash';
export default {
    data() {
        return {
			title: store.promotion.title,
			explainTitle: store.promotion.explainTitle,
			explainText: store.promotion.explainText,
			list: store.promotion.list
        }
	}
}
</script>

<template>
    <div class="wrap">
        <div class="title">
        	{{title}}
        </div>
        <div class="main">
        	<div class="double-card" :class="'double-card-'+index" v-for="(item, index) in list" :key="item.title">
				<div class="card">
					<div class="card-title">{{item.title}}</div>
					<div class="card-text" v-html="item.text"></div>
				</div>
        	</div>
			<div class="explain">
				<div class="text">{{explainTitle}}:</div>
				<div class="text" v-html="explainText"></div>
			</div>
        </div>
    </div>
</template>
<style lang="stylus" scoped>
.title
	text-indent -999px
	height 3.1rem
.wrap
	margin 0 0.8rem 0.37rem
	height 34.03rem
	font-size 0
	overflow hidden
	background url("../../assets/yhhd_bg2.png") no-repeat
	background-size 100%
	.main
		position relative
		height 30.35rem
		// 解决inline-block空白
		font-size 0
		.double-card
			position absolute
			height 4.8rem
			top 20rem
			width 100%
			box-sizing border-box
			.card
				color #fff
				.card-title
					font-size 0.96rem
					margin-bottom .37rem
				.card-text
					font-size 0.69rem
					line-height .9375rem
		.double-card-0 {
			padding-top .5rem
			top .4rem
			// background yellow
		}
		.double-card-1 {
			padding-top .5rem
			top 5.2rem
			height 4.8rem
			// background green
		}
		.double-card-2 {
			padding-top .7rem
			top 10rem
			height 4.8rem
			// background yellow
		}
		.double-card-3 {
			padding-top .7rem
			top 14.8rem
			height 4.8rem
			// background pink
		}
		.double-card-4 {
			padding-top .7rem
			top 19.6rem
			height 4.8rem
			// background blue
		}
		.double-card-1, .double-card-3 {
			padding-left 0.53rem
		}
		.double-card-0, .double-card-2, .double-card-4  {
			padding-right 0.53rem
			text-align right
		}
.explain
	position absolute
	top 24.4rem
	padding .5rem 0.5rem 0 
	.text
		text-align left
		font-size 0.53rem
		font-family PingFangSC-Semibold,PingFang SC
		font-weight 600
		color rgba(255,178,178,1)
		line-height 0.9rem
		//  @media screen and (max-width: 375px)
		// 	font-size 0.75rem
		// 	white-space nowrap
		// 	transform scale(0.832)
		// 	transform-origin left center

</style>